import { render, staticRenderFns } from "./SignName.vue?vue&type=template&id=18473aed&scoped=true&"
import script from "./SignName.vue?vue&type=script&lang=js&"
export * from "./SignName.vue?vue&type=script&lang=js&"
import style0 from "./SignName.vue?vue&type=style&index=0&id=18473aed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18473aed",
  null
  
)

export default component.exports